import React from "react";
import SEO from "../../seo";
import Productpage from "../../productpage2";
const gal_img_1 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-01.png";
const gal_img_2 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-02.png";
const gal_img_3 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-03.png";
const gal_img_4 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-04.png";

const warranty =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-05.png";

const feature =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-06.png";

const icon1 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-07.png";
const icon2 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-08.png";
const icon3 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-09.png";
const icon4 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-10.png";
const icon5 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-11.png";
const icon6 =
  "https://eclipsemattress.in/assets/images/products/tiara-cool/Tiera-Cool-12.png";

export default function TiaraCool({ location }) {
  const data = {
    galleryImages: [gal_img_4, gal_img_1, gal_img_2, gal_img_3],
    productName: "Tiara Cool",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/logos-044.png",
    descriptionTitle:
      "The Crowning Jewel Of Your Kingdom: Pocketed, Cool Gel & Visco Memory Foam Mattress",
    descriptionText:
      "Tiara Cool is the mattress that defines ‘the perfect fit’. This handicraft masterpiece molds itself to your body with its memory foam and cool gel layer, which is mounted on a superior body-supporting core of pocketed springs exclusive to the eclipse brand. For those cold winters morning and hot summer nights, it is designed for a thermally neutral and comfortable sleep, with memory foam and cool gel on one side and natural latex on the other, making it the most luxurious sleeping experience you deserve.",
    category: { title: "Patent Series", link: "/patent-series-mattress/" },
    points: [
      "Designed for thermally neutral sleep",
      "Specially formulated sprayed cool gel layer for consisted cooling upto 10 years",
      "Winter Side: Pocketed Spring & Natural Latex",
      "Summer Side: Memory Foam & Cool Gel Layer",
      "Reduces risk of heart attacks ",
    ],
    availableSizes: "8″ & 10″",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/features/logo-02.png",
      "https://eclipsemattress.in/assets/features/logo-05.png",
      "https://eclipsemattress.in/assets/features/logo-01.png",
      "https://eclipsemattress.in/assets/features/logo-06.png",
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
      icon6,
    ],
    featuresText: [
      "Eclipse Memory Foam soft quilted top",
      "HD Eclipse Pure Foam",
      "Turkish Cotton Felt",
      "Patented Life Edge Perimeter Support",
      "HD Pocket Spring System",
      "Eclipse Natural Belgium Latex",
    ],
    featuresImage: feature,
    warrantyImage: warranty,
    price: "₹86,899 - ₹2,71,099",

    relatedProducts: [
      {
        title: "Romance",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/romance.jpg",
        link: "/patent-series-mattress/romance/",
      },
      {
        title: "Coil On Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/coiloncoil.jpg",
        link: "/patent-series-mattress/coil-on-coil/",
      },
      {
        title: "Accolade PT",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/accolade-pt.jpg",
        link: "/patent-series-mattress/accolade-pt/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Buy Gel Foam Mattress | Eclipse International"
        description="Buy Tiara Cool gel foam mattress with 10 years warranty that is designed for a thermally neutral and comfortable sleep, with memory foam and cool gel on one side and natural latex on the other."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-tiaracool.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
